<w-single-select [options]="options" [(value)]="initialOption" (valueChange)="onValueChange($event)" [label]="label" [hideLabel]="hideLabel" highlightMode="size" fixedItemWidth="75px"></w-single-select>
